import FieldRAG, {RAG_AMBER, RAG_GREEN, RAG_NOT_SET, RAG_RED} from "../../../generic/rag/rag"
import FieldConfig from "../../../proto/field-config"
import FieldGoalHealth_InlineValueEmpty from "./components/inline-edit/value-empty"
import FieldGoalHealth_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldGoalHealth_GoalListEditable from "./render/goal-list-editable"
import FieldGoalHealth_GoalListView from "./render/goal-list-view"
import FieldGoalHealth_View from "./render/view"

const debug = false
// const debug = "FieldGoalHealth"

export default class FieldGoalHealth extends FieldRAG {

    FIELD_DEFAULT_WIDTH = 150

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel          = "Health"
        this.typeDescription    = "Goal health"
        this.clearButton        = _.get(config, 'clearButton', true)

        this.options    = [
            {value: RAG_NOT_SET,    label: 'Not set',       color: 1,   excludeFromSelectable: true},
            {value: RAG_RED,        label: 'Off track',     color: 2},
            {value: RAG_AMBER,      label: 'At risk',       color: 3},
            {value: RAG_GREEN,      label: 'In progress',   color: 4},
        ]
        this.hasOptionWithNullValue = _.some(this.options, option=>option.value === null)

        this.components.InlineValueEmpty        = FieldGoalHealth_InlineValueEmpty
        this.components.InlineValueNotEmpty     = FieldGoalHealth_InlineValueNotEmpty

        this.renderComponents.goalListEditable  = FieldGoalHealth_GoalListEditable
        this.renderComponents.goalListView      = FieldGoalHealth_GoalListView
        this.renderComponents.view              = FieldGoalHealth_View
    }
}
